export {default} from './HealthJourney.connect';
